import React from 'react';
import { Box, Text } from '@chakra-ui/react';

const Inventario = () => {
  return (
    <Box>
      <Text fontWeight="semibold" textStyle="4xl">Inventario</Text>
      <Text>Bienvenido a tus Inventario</Text>
    </Box>
  );
};

export default Inventario;
